
export { globalAPI } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/apis/new-apis/global-api.ts"